import Icon from '../../../../../components/icons/icon';
import { Typography } from '../../../../../components/typography/typography';

export const TagRemainingSpots = ({
  remainingSpots,
  tagName,
  tagLimit,
}: {
  remainingSpots: number;
  tagName: string;
  tagLimit: number;
}) => {
  return (
    <>
      {remainingSpots < 0 && (
        <div
          data-cy="tag-remaining-spots"
          className="flex flex-row gap-2 items-center rounded-[16px] bg-warning-50 p-4 border border-solid border-warning-500"
        >
          <Icon icon={'Warning'} dataCy="tag-remaining-spots-icon" stroke="var(--warning-800)" />
          <Typography
            type="text-sm"
            dataCy="tag-remaining-spots-text"
            className="text-warning-800"
          >{`This rental exceeds the renter’s limit of ${tagLimit} discounted items on rent for the "${tagName}" pricing rule.`}</Typography>
        </div>
      )}
    </>
  );
};
